<template>
  <div>
    <div ref="googleMap" class="google-map" />
    <template v-if="Boolean(google) && Boolean(map)">
      <slot :google="google" :map="map" />
    </template>
  </div>
</template>

<script>
const { VUE_APP_GOOGLE_MAPS_KEY } = process.env;
import { Loader } from "@googlemaps/js-api-loader";

export default {
  data() {
    return {
      google: null,
      map: null,
      mapObj: null,
      infowindow: null,
    };
  },
  props: {
    initOnMount: {
      type: Boolean,
      default: false,
    },
    mapData: {
      type: Object,
      default: null,
    },
    hideFoodMarkers: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  mounted() {
    const googleMapApi = new Loader({
      apiKey: VUE_APP_GOOGLE_MAPS_KEY,
      version: "weekly",
      libraries: ["places"],
    });
    this.google = googleMapApi;
    if (this.initOnMount) {
      this.initializeMap(this.mapData);
    }
  },
  methods: {
    createPlaceMarker(place) {
      const foodIcon = new google.maps.MarkerImage(
        "https://cdn.trailfinders.com/eotyrvyhnf_food-location.png",
        null,
        null,
        null,
        new google.maps.Size(30, 30)
      );
      const marker = new google.maps.Marker({
        map: this.mapObj,
        position: place.geometry.location,
        icon: foodIcon,
      });

      google.maps.event.addListener(marker, "click", () => {
        this.infowindow.setContent(place.name);
        this.infowindow.open(this.mapObj, marker);
      });
    },

    placesFound(results, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        for (let i = 0; i < results.length; i++) {
          this.createPlaceMarker(results[i]);
        }
      }
    },
    initializeMap(mapData) {
      const mapContainer = this.$refs.googleMap;
      this.map = this.google.load().then(() => {
        const latLong = new google.maps.LatLng(mapData.lat, mapData.lng);
        this.infowindow = new google.maps.InfoWindow();
        const mapConfig = {
          zoom: mapData.zoom ? mapData.zoom : 16,
          center: latLong,
          mapTypeId: google.maps.MapTypeId.TERRAIN,
          scaleControl: true,
          gestureHandling: "greedy",
        };
        const request = {
          location: latLong,
          radius: "10000",
          type: ["restaurant"],
        };
        const image = new google.maps.MarkerImage(
          "https://cdn.trailfinders.com/xoyvoiujqw_nonfeatured_bubble.png",
          null,
          null,
          null,
          new google.maps.Size(35, 35)
        );
        this.mapObj = new google.maps.Map(mapContainer, mapConfig);
        if (!this.hideFoodMarkers) {
          const placesService = new google.maps.places.PlacesService(
            this.mapObj
          );
          placesService.nearbySearch(request, this.placesFound);
        }
        const marker = new google.maps.Marker({
          position: latLong,
          icon: image,
        });
        marker.setMap(this.mapObj);
      });
    },
  },
};
</script>

<style>
@import "./styles.scss";
</style>
